export const ROUTE_HOME = "/";
export const ROUTE_ADD_BLOG = "/add-blog";
export const ROUTE_ABOUT = "/about";
export const ROUTE_PROTECTED = "/protected/internal/dashboard";
export const ROUTE_OTHER = "*";
export const ROUTE_STRIPE = "/payment/stripe";
